import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WelcomePopup from "./WelcomePopup";

export default function SiteShell({ children }) {
  return (
    <div className="min-h-screen bg-[#0b0b0b] text-white">
      <Navbar />
      <main className="pt-[78px]">{children}</main>
      <Footer />
      <WelcomePopup />
    </div>
  );
}
